import { styled } from 'styled-components'

export const ErrorStyled = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`